import { useState } from "react";
import AddPhoneCall from "../modals/AddPhoneCall";
import PhoneLoggerModal from "../modals/phonelogger/[id].jsx";

function GoalBar({ label, current, goal }) {
    const safeGoal = Math.max(Number(goal) || 1, 1);
    const safeCurrent = Math.max(Number(current) || 0, 0);
    const pct = Math.min(100, Math.round((safeCurrent / safeGoal) * 100));

    return (
        <div className="crm-conv-phone-goal-bar-block">
            <div className="crm-conv-phone-goal-bar-label-row">
                <span>{label}</span>
                <span>{safeCurrent}/{safeGoal}</span>
            </div>
            <div className="crm-conv-phone-goal-bar-track" role="progressbar" aria-valuenow={safeCurrent} aria-valuemin={0} aria-valuemax={safeGoal}>
                <div className="crm-conv-phone-goal-bar-fill" style={{ width: `${pct}%` }} />
            </div>
        </div>
    );
}

function formatCallTime(value) {
    if (!value) {
        return "-";
    }
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return value;
    }
    return date.toLocaleString([], {
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
    });
}

function PhoneCallsPanel({ calls, metrics, deals, contacts, onRefresh, loading, error }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedCall, setSelectedCall] = useState(null);
    const filteredCalls = Array.isArray(calls) ? calls : [];

    return (
        <section className="crm-conv-phone-calls-panel">
            <div className="crm-conv-phone-calls-top-row">
                <h3>Phone Calls</h3>

            </div>

            <div className="crm-conv-phone-metrics-grid">
                <GoalBar label="Daily Goal" current={metrics?.my_daily || 0} goal={metrics?.daily_goal || 60} />
                <GoalBar label="Weekly Team Goal" current={metrics?.team_weekly || 0} goal={metrics?.weekly_goal || 300} />
            </div>

            <div className="crm-conv-phone-count-chips">
                <span className="crm-conv-phone-count-chip">My Daily: {metrics?.my_daily || 0}</span>
                <span className="crm-conv-phone-count-chip">Team Daily: {metrics?.team_daily || 0}</span>
                <span className="crm-conv-phone-count-chip">My Weekly: {metrics?.my_weekly || 0}</span>
                <span className="crm-conv-phone-count-chip">Team Weekly: {metrics?.team_weekly || 0}</span>
            </div>

            {loading ? <div className="crm-conv-empty">Loading phone calls...</div> : null}
            {!loading && error ? <div className="crm-conv-empty">{error}</div> : null}
            {!loading && !error && filteredCalls.length === 0 ? (
                <div className="crm-conv-empty">No phone calls yet. Use Add Phone to log the first one.</div>
            ) : null}

            {!loading && !error && filteredCalls.length > 0 ? (
                <div className="crm-conv-phone-call-rows">
                    {filteredCalls.map((call) => (
                        <article key={String(call.id)} className="crm-conv-phone-call-row" role="button" tabIndex={0} onClick={() => setSelectedCall(call)} onKeyDown={(event) => { if (event.key === "Enter" || event.key === " ") { event.preventDefault(); setSelectedCall(call); } }}>
                            <div className="crm-conv-phone-call-row-main">
                                <div className="crm-conv-phone-call-row-title">
                                    {call.deal_title || "No deal linked"}
                                </div>
                                <div className="crm-conv-phone-call-row-subtitle">
                                    {call.user_name || "Unknown user"} · {String(call.direction || "outbound").toUpperCase()} · {String(call.call_type || "call").toUpperCase()}
                                </div>
                                <div className="crm-conv-phone-call-row-contact">
                                    Contact: {call.contact_name || call.manual_contact_name || "Unknown"}
                                </div>
                                <div className="crm-conv-phone-call-row-notes">{call.notes || "No notes"}</div>
                            </div>
                            <div className="crm-conv-phone-call-row-side">
                                <span>{formatCallTime(call.call_at)}</span>
                                <span>{Math.max(Number(call.duration_seconds) || 0, 0)}s</span>
                            </div>
                        </article>
                    ))}
                </div>
            ) : null}

            <AddPhoneCall
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                deals={deals}
                contacts={contacts}
                onCreated={() => {
                    setIsModalOpen(false);
                    onRefresh?.();
                }}
            />

			<PhoneLoggerModal
				isOpen={Boolean(selectedCall)}
				phoneCall={selectedCall}
				onClose={() => setSelectedCall(null)}
				onSaved={() => {
					setSelectedCall(null);
					onRefresh?.();
				}}
			/>
        </section>
    );
}

export default PhoneCallsPanel;
